const ChallengePreference = {
  NO_PREFERENCE: 'no_preference',
  CHALLENGE_MANDATORY: 'challenge_mandatory',
  CHALLENGE_REQUESTED: 'challenge_requested',
  NO_CHALLENGE: 'no_challenge',
};

module.exports = ChallengePreference;
